import { Services } from '../services'

export class SchedulingTask {
    id!: string
    indexId!: number
    departmentId!: number
    job!: string
    priority!: number
    phasePriority!: number
    name!: string
    crewAssignment!: string
    siteReady!: boolean
    materialsReady!: boolean
    estimatedStartDate!: Date
    estimatedHours!: number
    predecessorTaskId!: number
    materialsNeeded!: string
    notes!: string

    jobPriority!: number

    protected $setProperties(source: any, services: Services): void {
        source.jobPriority = services.data.schedulingJobs.items.find(x => x.job == source.job)?.priority
    }
}
